<script context='module'>
  import { getContext, onDestroy } from 'svelte';

  export const CONTEXT_KEY = Symbol('JobStartedTrayProvider.CONTEXT_KEY');
  export const useJobStartedTray = () => getContext(CONTEXT_KEY);
</script>

<script>
  import { derived } from 'svelte/store';
  import Provider from '@commercebear/components/Provider';
  import { getStores } from '$app/stores';
  import JobStartedTray from '../JobStartedTray';

  const { page } = getStores();
  const path = derived(page, ($page) => $page.url.pathname);

  let jobType;
  let tray;
  let currentPath;

  const trayInterface = {
    show(forJobType) {
      jobType = forJobType;
      tray?.show();
    },
    dismiss() {
      tray?.dismiss();
    },
  };

  const unsubscribe = path.subscribe((newPath) => {
    if (newPath !== currentPath) {
      trayInterface.dismiss();
    }
    currentPath = newPath;
  });

  onDestroy(unsubscribe);
</script>

<Provider key={CONTEXT_KEY} value={trayInterface}>
  <slot />
  <JobStartedTray {jobType} bind:tray/>
</Provider>
